// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__go0QL","customMenu":"Sidebar_customMenu__gWbJF","menuList":"Sidebar_menuList__rARS6","button":"Sidebar_button__Mbnbt","active":"Sidebar_active__K5Ns8"};